import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './routes';
import { ReactQueryProvider } from './lib/react-query';
import { TooltipProvider } from './components/ui/tooltip';
import { CollaborationProvider } from './providers/CollaborationProvider';
import { useAuth } from './hooks/useAuth';
import { useRealtimeSync } from './hooks/useRealtimeSync';
import { Toaster } from 'sonner';

function CollaborationWrapper({ children }: { children: React.ReactNode }) {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user) {
    return <>{children}</>;
  }

  const displayName = [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email || 'User';

  return (
    <CollaborationProvider userId={user.id} displayName={displayName}>
      <RealtimeSyncLayer>{children}</RealtimeSyncLayer>
    </CollaborationProvider>
  );
}

function RealtimeSyncLayer({ children }: { children: React.ReactNode }) {
  useRealtimeSync();
  return <>{children}</>;
}

function App() {
  return (
    <ReactQueryProvider>
      <TooltipProvider>
        <BrowserRouter>
          <CollaborationWrapper>
            <AppRoutes />
          </CollaborationWrapper>
        </BrowserRouter>
      </TooltipProvider>
      <Toaster position="bottom-right" richColors closeButton />
    </ReactQueryProvider>
  );
}

export default App;
